import { api } from './client';
import type { CommentDto } from './types';

export function listComments(taskId: string): Promise<CommentDto[]> {
  return api<CommentDto[]>(`/tasks/${taskId}/comments`);
}

export function addComment(taskId: string, body: string): Promise<CommentDto> {
  return api<CommentDto>(`/tasks/${taskId}/comments`, { method: 'POST', body: { body } });
}

export function deleteComment(commentId: string): Promise<void> {
  return api<void>(`/comments/${commentId}`, { method: 'DELETE' });
}
